const {
    REACT_APP_BASE_URL,
    REACT_APP_GOOGLE_LOGIN_CLIENT_ID,
    REACT_APP_ENABLE_WALLET,
    REACT_APP_MICROSOFT_LOGIN_CLIENT_ID,
    REACT_APP_GI_TENANT_URL,
} = process.env;

const isLocal = process.env.NODE_ENV === "development";

let config = {
    REACT_APP_BASE_URL: isLocal ? window.location.origin : (REACT_APP_BASE_URL || ""),
    GOOGLE_LOGIN_CLIENT_ID: REACT_APP_GOOGLE_LOGIN_CLIENT_ID || "",
    REACT_APP_ENABLE_WALLET: REACT_APP_ENABLE_WALLET === 'true',
    REACT_APP_ENABLE_DATADUMPSQL: true,
    MICROSOFT_LOGIN_CLIENT_ID: REACT_APP_MICROSOFT_LOGIN_CLIENT_ID || "",
    MICROSOFT_LOGIN_TENANT_ID: REACT_APP_GI_TENANT_URL || "",
}

export default config;